import { Link } from 'react-router-dom';
import { formatDate, formatDateTime, formatMoney, plural } from '../../check-batch/format';
import type { ContractorBatch } from '../types';
import { checkNumberRange } from '../helpers';

/**
 * Step 4. "Contractor Payment Approved" for exactly one contractor, "Payment Batch Approved" for two or more. The text states what approval is: a record
 * of approval. Nothing here says a check was printed, mailed or paid.
 */
export function ContractorApproved({ batch, onBack }: { batch: ContractorBatch; onBack: () => void }) {
  const a = batch.approval;
  if (!a) return null;
  const single = a.contractorCount === 1;
  const numbers = a.firstCheckNumber !== null && a.lastCheckNumber !== null && a.contractorCount > 1 ? `${a.firstCheckNumber} - ${a.lastCheckNumber}` : checkNumberRange(a.checkNumbers);
  return (
    <section className="wc-approved" aria-labelledby="wc-approved-title">
      <div className="wc-approved__badge" aria-hidden="true">✓</div>
      <h3 id="wc-approved-title">{single ? 'Contractor Payment Approved' : 'Payment Batch Approved'}</h3>
      <p className="wc-approved__text" role="status">
        {single ? 'The contractor payment' : 'The payment batch'} has been approved.
        {a.isPreview && ' This is a preview: no check was printed, mailed or paid.'}
      </p>
      <p className="wc-batch-id" data-testid="batch-reference">Batch ID: {a.reference}</p>
      <dl className="wc-cards wc-cards--narrow">
        <div><dt>Payment Method</dt><dd>Write Check</dd></div>
        <div><dt>Pay Date</dt><dd>{formatDate(a.payDate)}</dd></div>
        <div><dt>{single ? 'Contractor to be paid' : 'Contractors to be paid'}</dt><dd data-testid="approved-count">{plural(a.contractorCount, 'Contractor', 'Contractors')}</dd></div>
        <div><dt>Check {a.checkNumbers.length === 1 ? 'Number' : 'Numbers'}</dt><dd data-testid="approved-numbers">{numbers}</dd></div>
        <div className="wc-cards__wide">
          <dt>Total Amount</dt>
          <dd><span data-testid="approved-total">{formatMoney(a.checkTotal)}</span> <span className="wc-chip wc-chip--ok">Approved</span></dd>
        </div>
        <div><dt>Processed and Approved By</dt><dd>{a.approvedByEmail}</dd></div>
        <div><dt>Processed At</dt><dd>{formatDateTime(a.approvedAtUtc)}</dd></div>
      </dl>
      <div className="wc-approved__actions">
        <button type="button" className="wc-btn wc-btn--outline" onClick={onBack}>Back to Pay Contractors</button>
        <Link className="wc-btn wc-btn--green" to="/payroll/contractor-payments">View Contractor Payments</Link>
      </div>
    </section>
  );
}
